import React from 'react';
import { Button } from 'react-bootstrap';
import { FaFileDownload } from 'react-icons/fa';

/**
 * SaveButtonコンポーネント用のPropsです。
 * @interface SaveButtonProps
 */
interface SaveButtonProps {
  /**
   * ボタンクリック時の動作を設定する関数
   * @memberof SaveButtonProps
   */
  onClick: () => void;
}

/**
 * 一次保存ボタンコンポーネントです。
 * @param {function} props.onClick - ボタンクリック時に呼ばれるコールバック関数
 * @returns {JSX.Element} - 一次保存ボタンのJSX要素
 */
const SaveButton: React.FC<SaveButtonProps> = ({ onClick }) => {
  return (
    <Button
      variant="outline-secondary"
      className="save-button"
      size="sm"
      onClick={onClick}
    >
      <FaFileDownload />
      <span className="ms-1">一次保存</span>
    </Button>
  );
}

export default SaveButton;